<template>
  <div id="pageItemList">
    <page-header></page-header>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                :placeholder="$t('fulltextSearch')"
                v-model="searchInput"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="headers"
                :items="sparePartTypes"
                :rows-per-page-items="[10, 25, 50]"
                :pagination.sync="pagination"
                :total-items="sparePartTypesCount"
                :loading="sparePartTypeIsLoading"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.name }}</td>
                  <td>
                    <v-btn
                      flat
                      icon
                      color="info"
                      @click="editAction(props.item.id)"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                    <v-btn
                      flat
                      icon
                      color="red"
                      @click="$refs.deleteDialog.deleteAction(props.item)"
                    >
                      <v-icon>delete</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <spare-part-type-create-edit-dialog
      v-model="modal"
      @saved="fetchItems"
    ></spare-part-type-create-edit-dialog>

    <delete-dialog
      messageKey="deleteSparePartType"
      ref="deleteDialog"
      @confirm="deleteConfirmation"
    ></delete-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_SPARE_PART_TYPES,
  FETCH_SPARE_PART_TYPE,
  DELETE_SPARE_PART_TYPE,
  SHOW_SNACKBAR
} from "@/store/actions.type";
import refreshButtonMixin from "@/mixins/refreshButton.mixin";
import createButtonMixin from "@/mixins/createButton.mixin";
import searchInputMixin from "@/mixins/searchInput.mixin";
import paginationMixin from "@/mixins/pagination.mixin";
import SparePartTypesCreateEditDialog from "@/views/SparePart/SparePartTypesCreateEditDialog.vue";

export default {
  components: {
    "spare-part-type-create-edit-dialog": SparePartTypesCreateEditDialog
  },
  data() {
    return {
      pagination: {
        sortBy: "name",
        descending: false
      },
      modal: {
        show: false,
        mode: ""
      },
      headers: [
        { text: "#", value: "id" },
        { text: this.$t("name"), value: "name" },
        { text: this.$t("actions"), sortable: false }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "sparePartTypes",
      "sparePartTypesCount",
      "sparePartType",
      "sparePartTypeIsLoading",
      "createButton",
      "refreshButton"
    ])
  },
  mixins: [
    refreshButtonMixin,
    createButtonMixin,
    searchInputMixin,
    paginationMixin
  ],
  methods: {
    fetchItems() {
      this.$store.dispatch(FETCH_SPARE_PART_TYPES, [
        this.pagination,
        this.search
      ]);
    },
    createAction() {
      this.modal.mode = "create";
      this.modal.show = true;
    },
    editAction(id) {
      this.$store.dispatch(FETCH_SPARE_PART_TYPE, id).then(() => {
        this.modal.mode = "edit";
        this.modal.show = true;
      });
    },
    deleteConfirmation(sparePartType) {
      this.$store
        .dispatch(DELETE_SPARE_PART_TYPE, sparePartType.id)
        .then(() => {
          this.$store.dispatch(SHOW_SNACKBAR, {
            text: this.$t("deletedSuccessfully", [this.$t("sparePartType")]),
            color: "success"
          });

          this.fetchItems();
        });
    }
  }
};
</script>

<style scoped></style>
